import { render, staticRenderFns } from "./default_header.vue?vue&type=template&id=8975f5aa&scoped=true&"
import script from "./default_header.vue?vue&type=script&lang=js&"
export * from "./default_header.vue?vue&type=script&lang=js&"
import style0 from "./default_header.vue?vue&type=style&index=0&id=8975f5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975f5aa",
  null
  
)

export default component.exports